var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-item",class:{
    'status-pending': _vm.item.contentApprovalStatus === 'pending',
    'status-approved': _vm.item.contentApprovalStatus === 'approved',
    'status-rejected': _vm.item.contentApprovalStatus === 'rejected',
  },on:{"click":function($event){$event.preventDefault();return _vm.onClickPopupItem($event)}}},[_c('div',{staticClass:"item-thumbnail",style:({
      'background-image': _vm.item.thumbnailUrl
        ? ("url(" + (_vm.item.thumbnailUrl) + ")")
        : null,
    })}),_c('div',{staticClass:"item-detail"},[_c('h5',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.item.name))]),_c('item-attributes',{attrs:{"item":_vm.item}})],1),_c('div',{staticClass:"item-status",style:({
      'background-image': _vm.getStatusImageUrl(_vm.item.contentApprovalStatus),
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }